<template>
  <div class="onLineShopDetailContainer">
    <div class="breadNav">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/onLineShop' }"
          >在线商城</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/onLineShopDetail' }"
          >商品详情</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <div class="productTitle">
      <span>{{ productInfo.name }}</span>
    </div>
    <div class="content">
      <div class="content_left">
        <div class="content_carousel">
          <el-carousel
            ref="carousel"
            :interval="5000"
            arrow="always"
            height="420px"
          >
            <el-carousel-item
              v-for="(item, index) in productInfo.imgs
                ? productInfo.imgs.split(',')
                : []"
              :key="index"
            >
              <img :src="item" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="content_carousel_img">
          <div
            v-for="(item, index) in productInfo.imgs
              ? productInfo.imgs.split(',')
              : []"
            :key="index"
            @click="changeMainImg(index)"
          >
            <img :src="item" />
          </div>
        </div>
      </div>
      <div class="content_right">
        <div class="property">
          <span class="option">价格：</span>
          <span
            class="opt_cont"
            :title="productInfo.price + productInfo.category"
            >{{ productInfo.price + productInfo.category }}</span
          >
        </div>
        <div class="property">
          <span class="option">起批量：</span>
          <span class="opt_cont" :title="productInfo.sellStart">{{
            productInfo.sellStart
          }}</span>
        </div>
        <div class="property">
          <span class="option">供应量：</span>
          <span class="opt_cont" :title="productInfo.sellNum">{{
            productInfo.sellNum
          }}</span>
        </div>
        <div class="property">
          <span class="option">供应商：</span>
          <span class="opt_cont" :title="productInfo.supplier">{{
            productInfo.supplier
          }}</span>
        </div>
        <div class="property">
          <span class="option">产地：</span>
          <span class="opt_cont" :title="productInfo.address">{{
            productInfo.address
          }}</span>
        </div>
        <div class="property">
          <span class="option">品类：</span>
          <span class="opt_cont" :title="productInfo.category">{{
            productInfo.category
          }}</span>
        </div>
        <div class="property">
          <span class="option">品种：</span>
          <span class="opt_cont" :title="productInfo.variety">{{
            productInfo.variety
          }}</span>
        </div>
        <div class="property">
          <span class="option">库存：</span>
          <span class="opt_cont" :title="productInfo.stockNum">{{
            productInfo.stockNum
          }}</span>
        </div>
        <div class="property">
          <span class="option">联系方式：</span>
          <span class="opt_cont" :title="productInfo.tel">{{
            productInfo.tel
          }}</span>
        </div>
      </div>
    </div>
    <div class="remark">
      <div class="navList">
        <div class="nav">
          <span>商品详情</span>
        </div>
      </div>
      <div class="description" v-html="productInfo.description"></div>
    </div>
  </div>
</template>

<script>
import { getProductsInfo } from '../api/在线商城'

export default {
  data () {
    return {
      productInfo: {},
    }
  },
  methods: {
    changeMainImg (i) {
      this.$refs.carousel.setActiveItem(i)
    }
  },
  mounted () {
    getProductsInfo({ id: this.$route.query.id }).then(res => {
      this.productInfo = res.data.data
    })
  },
}
</script>

<style lang="scss" scoped>
*,
html,
body {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
img {
  display: block;
}
/deep/ .el-breadcrumb__item {
  font-size: 18px;
}
.onLineShopDetailContainer {
  width: 1600px;
  margin: 0 auto;
  min-height: 810px;
  background-color: #fff;
  padding: 30px 20px;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.2);
  .breadNav {
    margin-bottom: 30px;
  }
  .productTitle {
    margin-bottom: 20px;
    span {
      font-size: 30px;
    }
  }
  .content {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
    .content_left {
      min-width: 600px;
      width: 600px;
      height: 600px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      .content_carousel {
        height: 420px;
        width: 100%;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .content_carousel_img {
        flex: 1;
        width: 100%;
        margin-top: 10px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-column-gap: 20px;
        div {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img {
            max-width: 100%;
            max-height: 100%;
            height: auto;
            width: auto;
            display: block;
          }
        }
      }
    }
    .content_right {
      width: 840px;
      height: 600px;
      margin-left: 120px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: left;
      .property {
        display: flex;
        align-items: center;
        margin-bottom: 28px;
        width: 100%;
        &:last-child {
          margin-bottom: 0;
        }
        .option {
          font-size: 28px;
        }
        .opt_cont {
          font-size: 28px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          flex: 1;
        }
      }
    }
  }
  .remark {
    margin-top: 30px;
    border: 1px solid #ddd;
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
    height: auto;
    .navList {
      display: flex;
      align-items: center;
      flex-flow: row nowrap;
      width: 100%;
      background-color: #f5f7fa;
      height: 60px;
      .nav {
        height: 60px;
        line-height: 60px;
        width: 140px;
        text-align: center;
        background-color: #fff;
        span {
          font-size: 20px;
          color: #2187ff;
        }
      }
    }
    .description {
    }
  }
}
</style>